"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
const equipmentItems = [{
  id: 1,
  name: "Excavadora de servicio pesado",
  category: "Equipo de excavación",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/heavy_duty_excavator_machinery.png"
}, {
  id: 2,
  name: "Camión volquete industrial",
  category: "Vehículos de transporte",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/industrial_dump_truck_vehicle.png"
}, {
  id: 3,
  name: "Cargador de ruedas",
  category: "Equipo de carga",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/wheel_loader_construction_machine.png"
}];
export default function BrowseOurConstructionCollection() {
  return null;
}